import { Component, ViewChild, ElementRef, AfterViewInit , OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, FormArray } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash';
import { ApiService } from '../../api/api.service';
import { AuthguardService } from '../../api/authguard.service';
import { first } from 'rxjs/operators';
import { result } from 'lodash';
import { Router } from '@angular/router';
import { FormService } from '../../api/form.service';

@Component({
  selector: 'app-testeditreg',
  templateUrl: './testeditreg.component.html',
  styleUrls: ['./testeditreg.component.css']
})
export class TesteditregComponent implements OnInit {

  fileUploadForm:any;
  dash_yearofpass:any;
  dash_edu_table:any;
  dash_prof_table:any;
  dash_wrkexp_table:any;


  constructor(
    private http: HttpClient,
    private formBuilder: FormBuilder,
    private api: ApiService,
    private AuthguardService: AuthguardService,
    private router: Router,
    private formaction: FormService
  ) {

   }

   canActivate(): boolean {
    if (!this.AuthguardService.gettoken()) {
        this.router.navigateByUrl("/testLogin");
    }
    return this.AuthguardService.gettoken();
}

  ngOnInit(): void {


    window.localStorage.getItem('regNo');
    var results = [{refno: window.localStorage.getItem('regNo')}];

    this.api.listDashboardEdu(results).subscribe((result:any)=>{
      console.log(result);
       this.dash_edu_table = result;

      console.log(this.fileUploadForm.get("qualificationFa") as FormArray)
      for(var i=0; i<this.dash_edu_table.length; i++){
        console.log(this.dash_edu_table[i]['nameofpass']);
        this.qualification().push(this.formBuilder.group({
          exampassed: this.dash_edu_table[i]['nameofpass'],
          yearpass: this.dash_edu_table[i]['yearofpass'],
          university: this.dash_edu_table[i]['board_university'],
          substudied: this.dash_edu_table[i]['substudied'],
          marks: this.dash_edu_table[i]['substudied'],
        }));

        // this.formBuilder.group({
        //   exampassed: 'bb',
        //   yearpass: 'aa',
        //   university: '',
        //   substudied: '',
        //   marks: '',
        // })

        //this.fileUploadForm.controls['qualificationFa']
        this.dash_yearofpass = JSON.stringify(this.dash_edu_table[i]['yearofpass']);
        //console.log("yearofpass: " + JSON.stringify(this.dash_edu_table[i]['yearofpass']));
      }
    });





    this.fileUploadForm = this.formBuilder.group({
      qualificationFa: this.formBuilder.array([]) ,
    });
  }




  onFormSubmit() {


    const formData = new FormData();
    formData.append('fileUploadForm', JSON.stringify(this.fileUploadForm.value));

    var myargs = formData;
    var myargsText = this.fileUploadForm.value;
    console.log(this.fileUploadForm.value)



  }




submitted = false;

get f() { return this.fileUploadForm.controls; }


//add tabele start

newQuantity(): FormGroup {
  return this.formBuilder.group({
    exampassed: '',
    yearpass: 'aa',
    university: '',
    substudied: '',
    marks: '',

  })
}


qualification() : FormArray {
  return this.fileUploadForm.get("qualificationFa") as FormArray
}

tests(){
  //console.log(this.fileUploadForm.get("qualificationFa").value.length as FormArray);
  console.log("newQuantity: " + this.newQuantity)
  console.log( this.qualification().push(this.newQuantity()));
}

addQualification() {
  this.qualification().push(this.newQuantity());

}

removeQualification(i:number) {
  //alert(i);
  this.qualification().removeAt(i);
}


// get skills() : FormArray {
//   return this.fileUploadForm.get("skills") as FormArray
// }

// newSkill(): FormGroup {
//   return this.formBuilder.group({
//     examination_name: '',
//     year_of_passing: '',
//     name_of_university: '',
//     sub_studied: '',
//     division_of_marks: '',
//   })
// }

// addSkills() {
// this.skills.push(this.newSkill());
// }

// removeSkill(i:number) {
// this.skills.removeAt(i);
// }

//add tabele End



logout(){
  localStorage.clear();
  this.router.navigateByUrl('/testLogin');
  //localStorage.removeItem("sessionStorage");
}

omit_text(event:any)
{
  var k;
   k = event.charCode;
   return((k > 64 && k < 91) || (k > 96 && k < 123) || k==32);
// return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
}
omit_text_number(event:any)
{
  var k;
   k = event.charCode;
   return((k > 64 && k < 91) || (k > 96 && k < 123) || (k >= 48 && k <= 57) || k==32);
// return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
}
omit_email(event:any)
{
  var k;
   k = event.charCode;
   return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 46 || k==64 || k==95 || k==32);
}
omit_number(event:any)
{
  var k;
   k = event.charCode;
   return((k >= 48 && k <= 57) || k==32);
// return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
}
omit_spl(event:any)
{
  var k;
   k = event.charCode;
   return((k > 64 && k < 91) || (k > 96 && k < 123) || (k >= 48 && k <= 57) || k == 47 || k==32);
// return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
}
omit_addres(event:any)
{
  var k;
   k = event.charCode;
   return((k > 64 && k < 91) || (k > 96 && k < 123) || (k >= 48 && k <= 57) || k==32);
// return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
}
omit_decimal(event:any)
{
  var k;
   k = event.charCode;
   return((k >= 48 && k <= 57) || k==32 || k == 46);
// return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
}
}


   //this.valtext1 = 'AAA';
    // if(window.localStorage.getItem('logged_in') == 'TRUE'){

    //   this.formaction.get_family_head_result().subscribe((result:any)=>{
    //     console.log(result);

    //     this.api.listDashboardEdu(result).subscribe((result:any)=>{
    //       console.log(result);
    //        this.dash_edu_table = result;


    //       for(var i=0; i<this.dash_edu_table.length; i++){
    //         console.log(this.qualification().value);
    //         this.qualification().push(this.newQuantity());
    //         this.dash_yearofpass = JSON.stringify(this.dash_edu_table[i]['yearofpass']);
    //         console.log("yearofpass: " + JSON.stringify(this.dash_edu_table[i]['yearofpass']));
    //       }
    //     });

    //   });
    // }
